import React, { useState } from "react";
import { Box } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

interface ThumbnailCardProps {
  size: number; // the square side of the image, in px
  src: string;
  hoverSrc?: string; // shown while the pointer is over the image, if given
  alt?: string;
  href?: string; // when given, the picture itself opens this route in a new tab
  actions?: React.ReactNode; // buttons shown just under the image
}

// One gallery cell: a square image (optionally swapping while hovered) with its actions beneath.
// Packed to the top, so the actions sit just under the image — a small gap above them, a little
// more below before the next row.
const ThumbnailCard: React.FC<ThumbnailCardProps> = ({ size, src, hoverSrc, alt, href, actions }) => {
  const [hover, setHover] = useState(false);
  const picture = (
    <img
      width={size}
      height={size}
      style={{ display: "block", maxWidth: size, maxHeight: size, objectFit: "contain" }}
      src={hover && hoverSrc ? hoverSrc : src}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      alt={alt}
      loading="lazy"
    />
  );
  return (
    <Box sx={{ height: "100%", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
      {href ? (
        <RouterLink to={href} target="_blank" rel="noopener">
          {picture}
        </RouterLink>
      ) : (
        picture
      )}
      {actions && <Box sx={{ display: "flex", gap: 1, mt: "2px" }}>{actions}</Box>}
    </Box>
  );
};

export default ThumbnailCard;
